// Header Authorization
export const HEADER_AUTHORIZATION = "Authorization";

export const A2A_MICRO_SERVICE = "a2a";
export const PAL_MICRO_SERVICE = "pal";
export const ACTIVE_DDA_STATUS = "active";
export const MICRO_PENDING_DDA_STATUS = "microPending";

export const ON = "on";
export const OFF = "off";

export const IAV_NEW = "iav_new";
export const IAV = "iav";
export const IAV_API = "iav_api";
export const IAV_MICRO = "iav_micro";
export const IAV_REFRESH = "iav_refresh";
export const MICRODEPOSIT = "microdeposit";

export const PENDING_AUTOMATIC_VERIFICATION_STATUS =
  "pending_automatic_verification";
export const PENDING_MANUAL_VERIFICATION_STATUS = "pending_manual_verification";
export const MANUALLY_VERIFIED_VERIFICATION_STATUS = "manually_verified";
// Trustly micro-deposit verification failed. We surface two distinct codes
// because they fire on different SDK panel events and are kept stable for
// backward compatibility with hosts that already switch on them. In practice
// they describe the same upstream failure; the terminal-event guard inside
// TrustlyIntegration ensures only the first one we observe reaches the host.
//
// FAILED_TO_VERIFY: emitted from the `new_location` panel event when Trustly
// redirects to the cancel URL with status=5 (typical happy-path-fail).
export const FAILED_TO_VERIFY = "FAILED_TO_VERIFY";
// TRUSTLY_FAILED_TO_VERIFY: emitted from the `close` panel event with
// status=5 - typically a follow-up to new_location, but also fires when the
// user closes the lightbox directly on the verification-failed screen.
export const TRUSTLY_FAILED_TO_VERIFY = "TRUSTLY_FAILED_TO_VERIFY";
// Surfaced when the Trustly lightbox loads but never reports any panel event
// within TRUSTLY_WATCHDOG_MS - protects users from an indefinite blank panel.
export const TRUSTLY_TIMEOUT = "TRUSTLY_TIMEOUT";
export const TRUSTLY_WATCHDOG_MS = 90_000;

export const DESKTOP_WIDTH = 360;
export const DESKTOP_HEIGHT = 536;

export const PZ_IAV_ID = "pz_iav";

export const TRUSTLY_IAV_PROVIDER = "trustly";

export const SUCCESS_IAV_STATUS = "success";
export const EXIT_IAV_STATUS = "exit";
export const ERROR_IAV_STATUS = "error";

// Trustly SDK panel event vocabulary. The lightbox calls our panel listener
// with a `command` and an `obj` whose `type`/`page` fields drive our control
// flow. Centralizing these strings keeps the switch statements in
// TrustlyIntegration.tsx readable and grep-friendly.
export const TRUSTLY_PANEL_COMMAND_EVENT = "event";
export const TRUSTLY_PANEL_EVENT_NEW_LOCATION = "new_location";
export const TRUSTLY_PANEL_EVENT_CLOSE = "close";
export const TRUSTLY_PANEL_PAGE_ERROR = "error";

// URLs we configure as `returnUrl`/`cancelUrl` on `Trustly.establish` and
// then match against the `obj.data` payload Trustly redirects to.
export const TRUSTLY_RETURN_URL = "#success";
export const TRUSTLY_CANCEL_URL = "#cancel";

// Cross-frame signal the Trustly OAuth pop-up posts back to us when the
// user finishes the bank login and the lightbox should advance to the
// account-chooser view.
export const TRUSTLY_PROCEED_TO_CHOOSE_ACCOUNT = "trustlyProceedToChooseAccount";

// Trustly micro-deposit "verification failed" status reported via the
// `status` query param on the cancel URL.
export const MICRO_DEPOSIT_VERIFICATION_FAILED_STATUS = "5";

// Reason key embedded in the watchdog log event so server-side analytics
// can distinguish stuck-panel timeouts from other ERROR_IAV_STATUS rows.
export const WATCHDOG_TIMEOUT_REASON = "watchdog_timeout";
